<template>
  <div
    :class="{ 'activity-wrapper': true, 'activity-wrapper-scroll': !isTablet }"
    :style="{
      padding: isTablet ? '25px 75px' : '25px 50px'
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const application = createNamespacedHelpers('application');
export default {
  name: 'activity-wrapper',
  computed: {
    ...application.mapState(['device']),
    isTablet() {
      return this.device.isMobile;
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.activity-wrapper-scroll {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
